/* global bsBreakpoints */

(() => {
	const bsBreakpoint = bsBreakpoints.detectBreakpoint();
	const bannerImg = document.querySelectorAll('[data-mobile-uri]') || null;

	if (bsBreakpoint === 'xSmall' && bannerImg) {
		bannerImg.forEach((banner) => {
			banner.style.backgroundImage = `url(
				${banner.getAttribute('data-mobile-uri')}
			)`;
		});
	}
})();
